/** @csi/widget/InvalidMessage */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/topic",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/html",
	"dojo/text!./InvalidMessage.html"
], function(declare, domClass, topic, _TemplatedMixin, _WidgetBase, html, template) {

	const ERROR = "exclamation-circle";
	const INFO = "info-circle";
	const NOICON = "csi-noicon";
	const REFRESH = "sync";
	const WARNING = "exclamation-triangle";

	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-invalid-message",
		templateString: template,
		iconNode: null,
		valueNode: null,

		// possible values for icon
		ERROR,
		INFO,
		REFRESH,
		WARNING,

		/** @property {boolean} bold - indicates if message should be displayed in bold */
		bold: false,

		/** @property {string} icon - Font Awesome icon to use for message */
		icon: ERROR,

		/** @property {number} maxWidth - max width of message display */
		maxWidth: 600,

		/** @property {string} value - message content */
		value: "",

		postCreate: function() {
			this.inherited(arguments);
			domClass.toggle(this.domNode, this.baseClass, !!this.value);
		},

		_setBoldAttr: {node: "domNode", type: "toggleClass"},

		/**
		 * Toggle icon class being used
		 */
		_setIconAttr: function(value) {
			const {domNode, icon, iconNode} = this;

			this._set("icon", value || "");
			domNode.classList.remove(icon || NOICON);
			domNode.classList.add(value || NOICON);
			html.clear(iconNode);

			if (value) {
				html.create("div", {
					className: `fas fa-${value}`
				}, iconNode);
			}
		},

		/**
		 * Set max width, so long content does not make parent too wide.
		 * @param {number} value
		 */
		_setMaxWidthAttr: function(value) {
			html.setPixels(this.domNode, html.MAXWIDTH, value);
			this._set("maxWidth", value);
		},

		/**
		 * Hide widget if no value, otherwise show widget with value
		 * @param {string} value
		 */
		_setValueAttr: function(value) {
			var domNode = this.domNode;
			this._set("value", value);
			html.clear(this.valueNode);

			if (value) {
				html.multiLineText(this.valueNode, value);
			}

			domClass.toggle(domNode, this.baseClass, !!this.value);

			if (value) { // avoid flicker when leaving wizard page/closing dialog 
				topic.publish("/csi/dialog/resize/required", true);
			}
		}
	});
});